{
  "logoPosition": "right",
  "pages": [
    {
      "name": "page1",
      "elements": [
        {
          "type": "dynamictable",
          "name": "dynamic_table_users",
          "title": "Brugere",
          "dataSource": "event_users_not_assigned",
          "enableSearch": true,
          "multiSelect": true,
          "simpleMultiSelect": true,
          "selectionKeyField": "uuid"
        },
        {
          "type": "boolean",
          "name": "send_notifications",
          "title": "Send notifikationer ved tilføjelse til event",
          "defaultValue": "true"
        },
        {
          "type": "boolean",
          "name": "event_waitlist_enabled",
          "visible": false,
          "defaultValue": "true"
        },
        {
          "type": "dropdown",
          "name": "enrollment_status",
          "title": "Tilmeldingsstatus",
          "defaultValue": "participant",
          "choices": [
            {
              "value": "participant",
              "text": "Deltager"
            },
            {
              "value": "waitlist",
              "text": "Venteliste"
            },
            {
              "value": "instructor",
              "text": "Instruktør"
            }
          ]
        }
      ]
    }
  ],
  "completeText": "Tilføj",
  "showEmptyFormSubmit": true
}
